import { Injectable } from '@angular/core';
import { HttpClient, HttpContextToken, HttpHeaders } from '@angular/common/http';

// Import environment
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getAll = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/user', { params })
  }
   getAssetBalance = (params: any) => {
        return this.http.get(environment.walletApiUrl + 'api/admin/asset-report', { params })
    }
    
  getUserReport(userId: string) {
  return this.http.get<any>(`https://walletapi.credbull.in/api/admin/getUserReport/${userId}`);
}

 getAllCurrentPrice = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/priceCNV', { params })
  }
  getAllDocs = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/user', { params, responseType: 'text' as 'json' })
  }

  balReportDocs = () => {
    return this.http.get(environment.walletApiUrl + 'api/admin/balance/report/export', { responseType: 'text' as 'json' })
  }

  disable2FA = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/disable-2fa', data)
  }

  userActivate = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/userActivate', data)
  }

  resendMailApi = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/resendMail', data)
  }

  userLockApi = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/user-locked', data)
  }

  deleteAccount = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/user/delete', data)
  }

  getUserAssetApi = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAsset', { params })
  }
getWalletDetails(_id: any) {
  return this.http.get(`${environment.walletApiUrl}api/admin/getUserReport/${_id}`);
}
    getCurrentPrice= (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/priceCNV', { params })
  }
  // download api
  getUserAssetDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAsset', { params, responseType: 'text' as 'json' })
  }

  getPassbookList = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getpassbook', { params })
  }

  // getTestingDatat = (data: any) => {
  //   return this.http.post(environment.botApiUrl + 'api/subscription/purchasePlanTesting',  data )
  // }

  // cancelOrderAdmin = (data: any) => {
  //   return this.http.post(environment.spotApiUrl + '/api/spot/cancelOrderAdmin',  data )
  // }

  getAdminrepsort = () => {
    return this.http.get(environment.spotApiUrl + '/api/admin/getUserCoinList',{responseType: 'text' as 'json'} )
  }

  

  getFakePassbookList = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsers', { params })
  }

  getZeroBalPassbookIssue = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/zero-bal-passbook-issues', { params })
  }

  getFakeAmountForUsersCoinDCX = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsersCoinDCX', { params })
  }

  getFakeAmountForUsersCoinDCXDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsersCoinDCX', { params, responseType: 'text' as 'json' })
  }

  

  getFakeAmountForUsersCancelOrderBin = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsersCancelOrderBin', { params })
  }

  getFakeAmountForUsersCancelOrderCoinDcx = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsersCancelOrderCoinDcx', { params })
  }
  getFakeAmountForUsers= (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsersCoinDCX', { params })
  }
  getFakeCredAmountForUsers= (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getCredFakeAmountForUsers', { params })
  }
  getFakeAmountForUsersCancelOrderBinDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsersCancelOrderBin', { params, responseType: 'text' as 'json' })
  }

  getFakeAmountForUsersCancelOrderCoinDcxDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsersCancelOrderCoinDcx', { params, responseType: 'text' as 'json' })
  }



  getFakePassbookListDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getFakeAmountForUsers', { params, responseType: 'text' as 'json' })
  }

  // passbook list downloader api
  getPassbookDocs = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getpassbook', { params, responseType: 'text' as 'json' })
  }

  getUserPassbookList = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/userPassBookHistory', { params })
  }

  // user's passbook downloader api
  downloadDocs = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/userPassBookHistory', { params, responseType: 'text' as 'json' })
  }

  updateAsset = (data: any) => {
    return this.http.put(environment.walletApiUrl + 'api/admin/updateUserAsset', data)
  }

  getAllKyc = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/userKyc', { params })
  }

    getUserAssetApiListDoc = () => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAssetList', { responseType: 'text' as 'json' })
  }
  rejectKyc = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/userKyc', data)
  }

  approveKyc = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/userKyc', data)
  }

  // kyc downlader api
  getAllKycDocs = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/userKyc', { params, responseType: 'text' as 'json' })
  }

  getSingleKyc = (id: string) => {
    return this.http.get(environment.userApiUrl + `api/admin/userKyc/${id}`)
  }

  getBank = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/getBankData', { params })
  }

  findByBankId = (id: string, userId: string) => {
    return this.http.get(environment.userApiUrl + 'api/admin/getBanksingle/' + id + "/" + userId)
  }

  updateBank = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/updateBank', data)
  }

  deleteBank = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/updateBank', data)
  }
  updateBankstatus = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/updateBankstatus', data)
  }
  userLoginHistory = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/userLoginHistory', { params })
  }


  fiatDepositecommission = (params:any)=>{

    return this.http.get(environment.walletApiUrl + 'api/admin/fiatDepositForBuyCoinList' ,{ params })
  }
  fiatDepositecommissionXLS = (token:any)=>{

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    return this.http.put(environment.walletApiUrl + 'api/admin/fiatDepositForBuyCoinList' , {} , {headers})
  }

}
